<template>
  <div class="card-repeat" v-if="productItem">
    <div class="product-info d-flex justify-content-between">
      <div class="d-flex justify-content-between">
        <div class="d-flex">
          <i
            class="mr8 mt4"
            :class="[productItem.isVeg ? 'tag-veg' : 'tag-non-veg']"
          ></i>
          <div>
            <span class="product-title bold fs-14">{{
              productItem?.displayName
            }}</span>
            <div class="d-flex justify-content-between align-items-center mt5">
              <ul
                v-if="itemsInCombo"
                class="justify-content-between fs-12 lh18"
              >
                <li
                  class="color-grey disc-list"
                  v-for="(item, index) in itemsInCombo"
                  :key="index"
                >
                  {{ productObj[item]?.name }}
                </li>
              </ul>
              <ul v-else class="justify-content-between fs-12 lh18">
                <li class="color-grey disc-list">
                  {{ productItem?.selectedVariant?.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div v-if="showEditMiniCartModal">
          <div
            class="btn cta-edit medium"
            v-if="itemsQuantityMiniCartCust[dataKey] > 0"
          >
            <span
              class="anim-ico-minus item-status-anim"
              @click="
                $emit('removeFromCartForCombo', itemsListMiniCartCust[dataKey])
              "
              v-ripple
            >
            </span>
            <span class="item-quantity">{{
              itemsQuantityMiniCartCust[dataKey]
            }}</span>
            <span
              class="anim-ico-plus tr item-status-anim"
              @click="
                $emit('addToCartForCombo', itemsListMiniCartCust[dataKey])
              "
              v-ripple
            ></span>
          </div>
          <div
            v-else
            class="btn medium bold hand cta-add"
            @click="$emit('addToCartForCombo', productItem)"
            v-ripple
          >
            Add
          </div>
        </div>
        <div class="d-flex mt4">
          <span
            class="color-grey fs-11 mr3"
            v-if="
              regularProductPrice &&
              regularProductPrice - currentProductPrice &&
              regularProductPrice > currentProductPrice
            "
          >
            <i class="rs">Rs.</i
            ><span class="strike-diagonal-price">
              {{ regularProductPrice }}
            </span>
          </span>
          <div class="product-price fs-12">
            <i class="rs">Rs.</i>
            <span>
              {{ currentProductPrice }}
            </span>
          </div>
        </div>

        <div class="savings mt4" v-if="discount && discount > 0">
          <span class="fs-10 fw-700">SAVE</span>
          <span class="fs-10 normal">
            <i class="rs">Rs.</i
            ><span class="fw-700">
              {{ discount.toFixed(2) }}
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "RepeatEditProductCart",
  props: {
    dataItem: { required: true, default: {} },
    dataKey: { required: false, default: "" },
  },
  data() {
    return {
      productItem: {},
      productsFilteredArray: [],
      productObj: {},
      currentProductPrice: 0,
      regularProductPrice: 0,
      discount: 0,
    };
  },
  mounted() {
    this.productItem = this.dataItem;
    this.productsFilteredArray = Object.values(
      this.$store.state.ProductItems.productsFiltered
    );
    this.productObj = this.productsFilteredArray.reduce(
      (pv, cv) => Object.assign(pv, cv),
      {}
    );
    this.currentProductPrice = this.productItem?.selectedVariant
      ? parseFloat(
          this.productItem?.selectedVariant?.price?.currentPrice.toFixed(2)
        )
      : parseFloat(this.productItem?.price?.currentPrice.toFixed(2));
    this.regularProductPrice = this.productItem?.selectedVariant
      ? parseFloat(
          this.productItem?.selectedVariant?.price?.regularPrice.toFixed(2)
        )
      : parseFloat(this.productItem?.price?.regularPrice.toFixed(2));
    this.discount = this.regularProductPrice - this.currentProductPrice;
  },
  computed: {
    itemsInCombo() {
      let productItemsIdArray = this.productItem?.selectedComboVariant
        ?.map((x) => x?.items?.map((i) => i?.parentSkuId))
        .flat();
      return productItemsIdArray;
    },
    showEditMiniCartModal() {
      return this.$store.state.ProductItems.showEditMiniCartModal;
    },
    itemsQuantityMiniCartCust() {
      return this.$store.state.ProductItems.itemsQuantityMiniCartCust;
    },
    itemsListMiniCartCust() {
      return this.$store.state.ProductItems.itemsListMiniCartCust;
    },
  },
};
</script>
<style></style>
